import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthResponse } from '../../assets/interfaces/authResponse';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private testUrl = '../../assets/data';
  private prodUrl = 'https://www.cloverpupcrew.com/AppService';

  constructor(private http: HttpClient) { }

  postAuthLogin(user: string, password: string): Observable<AuthResponse> {
    const body = {USER: user, PASS: password};
    return this.http.post<AuthResponse>(this.prodUrl + '/auth.php', body); // prod
    // return this.http.get<AuthResponse>(this.testUrl + '/auth.json'); // local for testing
  }
}
